// Generated by CoffeeScript 2.7.0
var AVATAR_TYPE, SettingsNamecard, TEXT_TYPE, ingredientLabel;

import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js';

TEXT_TYPE = 'Frame::Ingredient::Text';

AVATAR_TYPE = 'Frame::Ingredient::Avatar';

ingredientLabel = function(kind) {
  if (kind === 'text') {
    return '文本';
  } else {
    return '头像';
  }
};

export default SettingsNamecard = Vue.extend({
  components: {
    'settings-container': SettingsContainer
  },
  props: {
    activeTab: {
      type: String
    },
    namecardData: {
      type: Object
    }
  },
  data: function() {
    return {
      frameUrl: this.namecardData.frame_url,
      previewUrl: this.namecardData.preview_url || '',
      paths: this.namecardData.paths,
      ingredients: this._normalizeIngredients(this.namecardData.ingredients),
      autoRefresh: false,
      frameUploading: false,
      showNewTextForm: false,
      showNewAvatarForm: false,
      newText: {
        type: TEXT_TYPE,
        pointsize: '',
        color: '',
        position: '',
        content: ''
      },
      newAvatar: {
        type: AVATAR_TYPE,
        pointsize: '',
        position: ''
      }
    };
  },
  template: `<settings-container :activeTab="activeTab">
  <template slot="content">
    <div class="namecard-settings">
      <div class="namecard-settings-columns">
        <div class="namecard-preview-panel">
          <div class="panel-card">
            <div class="panel-card-head justify-between">
              <span class="panel-card-title">预览</span>
              <button class="text-btn btn-danger btn-xs"
                      @click="refreshAllNamecards">更新名片</button>
            </div>
            <div class="panel-card-body">
              <div class="namecard-image-block">
                <img :src="frameUrl" alt="模板" class="namecard-frame-image" />
                <div class="namecard-image-caption">模板</div>
                <label class="namecard-upload-label" :class="{ disabled: frameUploading }">
                  <input type="file"
                         accept="image/*"
                         class="hidden-input"
                         @change="uploadFrame"
                         :disabled="frameUploading" />
                  <span class="text-success">{{ frameUploading ? '模板正在上传 ...' : '修改模板' }}</span>
                </label>
              </div>
              <div class="namecard-image-block">
                <img :src="previewUrl" alt="效果图" class="namecard-preview-image" />
                <div class="namecard-image-caption">效果图</div>
              </div>
            </div>
            <div class="panel-card-foot justify-between">
              <label class="namecard-auto-refresh">
                <span>实时刷新</span>
                <label class="switch">
                  <input type="checkbox" v-model="autoRefresh" />
                  <span></span>
                </label>
              </label>
              <button class="btn btn-primary btn-xs" @click="generatePreview">预览</button>
            </div>
          </div>
        </div>

        <div class="namecard-ingredients-panel">
          <div class="panel-card">
            <div class="panel-card-head">
              <span class="panel-card-title">素材</span>
            </div>
            <div class="panel-card-body ingredients-list">
              <div v-for="ingredient in ingredients"
                   :key="ingredient.id"
                   class="ingredient-item"
                   :class="ingredient.mode">
                <div class="ingredient-item-show">
                  <span class="ingredient-kind-tag" :class="ingredient.kind">{{ ingredientLabel(ingredient.kind) }}</span>
                  <div class="ingredient-field" v-if="ingredient.kind === 'text'">
                    <span class="field-label">字体大小</span>
                    <span>{{ ingredient.pointsize }}</span>
                  </div>
                  <div class="ingredient-field" v-if="ingredient.kind === 'text'">
                    <span class="field-label">文本颜色</span>
                    <span class="color-swatch" :style="{ backgroundColor: ingredient.color }"></span>
                  </div>
                  <div class="ingredient-field">
                    <span class="field-label">{{ ingredient.kind === 'text' ? '文本位置' : '头像位置' }}</span>
                    <span>{{ ingredient.position }}</span>
                  </div>
                  <div class="ingredient-field ingredient-content" v-if="ingredient.kind === 'text'">
                    <span class="field-label">文本内容</span>
                    <span>{{ ingredient.display_content }}</span>
                  </div>
                  <div class="ingredient-field" v-if="ingredient.kind === 'avatar'">
                    <span class="field-label">头像尺寸</span>
                    <span>{{ ingredient.pointsize }}</span>
                  </div>
                  <div class="ingredient-actions">
                    <button class="icon-btn" @click="editIngredient(ingredient)"><i class="slp-edit"></i></button>
                    <button class="icon-btn" @click="confirmDeleteIngredient(ingredient)"><i class="slp-trash"></i></button>
                  </div>
                </div>

                <div class="ingredient-item-edit">
                  <span class="ingredient-kind-tag" :class="ingredient.kind">{{ ingredientLabel(ingredient.kind) }}</span>
                  <div class="ingredient-field" v-if="ingredient.kind === 'text'">
                    <span class="field-label">字体大小</span>
                    <input v-model.trim="ingredient.editForm.pointsize" class="form-field-value" />
                  </div>
                  <div class="ingredient-field" v-if="ingredient.kind === 'text'">
                    <span class="field-label">文本颜色</span>
                    <input v-model.trim="ingredient.editForm.color" class="form-field-value" />
                  </div>
                  <div class="ingredient-field">
                    <span class="field-label">{{ ingredient.kind === 'text' ? '文本位置' : '头像位置' }}</span>
                    <input v-model.trim="ingredient.editForm.position" class="form-field-value" />
                  </div>
                  <div class="ingredient-field" v-if="ingredient.kind === 'avatar'">
                    <span class="field-label">头像尺寸</span>
                    <input v-model.trim="ingredient.editForm.pointsize" class="form-field-value" />
                  </div>
                  <div class="ingredient-field ingredient-content" v-if="ingredient.kind === 'text'">
                    <span class="field-label">文本内容</span>
                    <input v-model.trim="ingredient.editForm.content" class="form-field-value" />
                  </div>
                  <div class="ingredient-actions">
                    <button class="icon-btn" @click="saveIngredient(ingredient)"><i class="slp-save"></i></button>
                    <button class="icon-btn" @click="cancelEditIngredient(ingredient)"><i class="slp-close"></i></button>
                  </div>
                </div>

                <div class="ingredient-item-delete">
                  <span class="ingredient-kind-tag" :class="ingredient.kind">{{ ingredientLabel(ingredient.kind) }}</span>
                  <div class="ingredient-delete-text">确认删除？</div>
                  <div class="ingredient-actions">
                    <button class="icon-btn" @click="deleteIngredient(ingredient)"><i class="slp-check"></i></button>
                    <button class="icon-btn" @click="cancelDeleteIngredient(ingredient)"><i class="slp-close"></i></button>
                  </div>
                </div>
              </div>

              <div v-if="showNewTextForm" class="ingredient-item new-ingredient">
                <span class="ingredient-kind-tag text">文本</span>
                <div class="ingredient-field">
                  <span class="field-label">字体大小</span>
                  <input v-model.trim="newText.pointsize" class="form-field-value" placeholder="12" />
                </div>
                <div class="ingredient-field">
                  <span class="field-label">文本颜色</span>
                  <input v-model.trim="newText.color" class="form-field-value" placeholder="#000000" />
                </div>
                <div class="ingredient-field">
                  <span class="field-label">文本位置</span>
                  <input v-model.trim="newText.position" class="form-field-value" placeholder="100,100" />
                </div>
                <div class="ingredient-field ingredient-content">
                  <span class="field-label">文本内容</span>
                  <input v-model.trim="newText.content" class="form-field-value" placeholder="你好" />
                </div>
                <div class="ingredient-actions">
                  <button class="icon-btn" @click="createTextIngredient"><i class="slp-save"></i></button>
                  <button class="icon-btn" @click="hideNewTextForm"><i class="slp-close"></i></button>
                </div>
              </div>

              <div v-if="showNewAvatarForm" class="ingredient-item new-ingredient">
                <span class="ingredient-kind-tag avatar">头像</span>
                <div class="ingredient-field">
                  <span class="field-label">头像尺寸</span>
                  <input v-model.trim="newAvatar.pointsize" class="form-field-value" placeholder="50,50" />
                </div>
                <div class="ingredient-field">
                  <span class="field-label">头像位置</span>
                  <input v-model.trim="newAvatar.position" class="form-field-value" placeholder="90,70" />
                </div>
                <div class="ingredient-actions">
                  <button class="icon-btn" @click="createAvatarIngredient"><i class="slp-save"></i></button>
                  <button class="icon-btn" @click="hideNewAvatarForm"><i class="slp-close"></i></button>
                </div>
              </div>
            </div>
            <div class="panel-card-foot justify-end">
              <button class="btn btn-default btn-xs" @click="openNewTextForm">添加文本</button>
              <button class="btn btn-default btn-xs" @click="openNewAvatarForm">添加头像</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
</settings-container>`,
  methods: {
    ingredientLabel: ingredientLabel,
    uploadFrame: function(event) {
      var file, formData;
      file = event.target.files[0];
      if (!file) {
        return;
      }
      formData = new FormData();
      formData.append('file', file);
      this.frameUploading = true;
      return Skylark.Libs.Ajax.patch(this.paths.frame, {
        data: formData,
        contentType: false,
        responseType: 'json',
        success: (data) => {
          this.frameUrl = data.frame;
          if (this.autoRefresh) {
            return this.generatePreview();
          }
        },
        error: () => {
          return Skylark.Bridge.newAlertify('模板上传失败', {
            type: 'danger'
          });
        },
        complete: () => {
          this.frameUploading = false;
          return event.target.value = '';
        }
      });
    },
    generatePreview: function() {
      return Skylark.Libs.Ajax.get(this.paths.preview, {
        responseType: 'json',
        success: (data) => {
          return this.previewUrl = data.preview_url;
        }
      });
    },
    refreshAllNamecards: function() {
      if (!window.confirm('确认更新所有用户的名片吗？')) {
        return;
      }
      return Skylark.Libs.Ajax.post(this.paths.refresh, {
        responseType: 'json',
        success: () => {
          return Skylark.Bridge.newAlertify('正在更新中，可能需要一定时间来更新所有用户的名片。', {
            type: 'success'
          });
        }
      });
    },
    editIngredient: function(ingredient) {
      ingredient.mode = 'edit';
      return ingredient.editForm = _.pick(ingredient, 'pointsize', 'position', 'color', 'content');
    },
    cancelEditIngredient: function(ingredient) {
      return ingredient.mode = 'show';
    },
    confirmDeleteIngredient: function(ingredient) {
      return ingredient.mode = 'delete';
    },
    cancelDeleteIngredient: function(ingredient) {
      return ingredient.mode = 'show';
    },
    saveIngredient: function(ingredient) {
      return Skylark.Libs.Ajax.patch(`${this.paths.ingredients}/${ingredient.id}.json`, {
        data: {
          ingredient: ingredient.editForm
        },
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: (data) => {
          this._replaceIngredient(data.ingredient);
          Skylark.Bridge.newAlertify('更新成功', {
            type: 'success'
          });
          if (this.autoRefresh) {
            return this.generatePreview();
          }
        },
        error: (xhr) => {
          return this._showErrors(xhr, '更新失败');
        }
      });
    },
    deleteIngredient: function(ingredient) {
      return Skylark.Libs.Ajax.delete(`${this.paths.ingredients}/${ingredient.id}.json`, {
        responseType: 'json',
        success: () => {
          this.ingredients = this.ingredients.filter(function(item) {
            return item.id !== ingredient.id;
          });
          Skylark.Bridge.newAlertify('删除成功', {
            type: 'success'
          });
          if (this.autoRefresh) {
            return this.generatePreview();
          }
        }
      });
    },
    openNewTextForm: function() {
      this.showNewAvatarForm = false;
      return this.showNewTextForm = true;
    },
    hideNewTextForm: function() {
      this.showNewTextForm = false;
      return this.newText = {
        type: TEXT_TYPE,
        pointsize: '',
        color: '',
        position: '',
        content: ''
      };
    },
    openNewAvatarForm: function() {
      this.showNewTextForm = false;
      return this.showNewAvatarForm = true;
    },
    hideNewAvatarForm: function() {
      this.showNewAvatarForm = false;
      return this.newAvatar = {
        type: AVATAR_TYPE,
        pointsize: '',
        position: ''
      };
    },
    createTextIngredient: function() {
      return this._createIngredient(this.newText, () => {
        return this.hideNewTextForm();
      });
    },
    createAvatarIngredient: function() {
      return this._createIngredient(this.newAvatar, () => {
        return this.hideNewAvatarForm();
      });
    },
    _createIngredient: function(payload, onSuccess) {
      return Skylark.Libs.Ajax.post(this.paths.ingredients, {
        data: {
          ingredient: payload
        },
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: (data) => {
          this.ingredients.push(this._decorateIngredient(data.ingredient));
          Skylark.Bridge.newAlertify('新建成功', {
            type: 'success'
          });
          if (typeof onSuccess === "function") {
            onSuccess();
          }
          if (this.autoRefresh) {
            return this.generatePreview();
          }
        },
        error: (xhr) => {
          return this._showErrors(xhr, '新建失败');
        }
      });
    },
    _replaceIngredient: function(ingredient) {
      var index;
      index = _.findIndex(this.ingredients, function(item) {
        return item.id === ingredient.id;
      });
      if (index < 0) {
        return;
      }
      return Vue.set(this.ingredients, index, this._decorateIngredient(ingredient));
    },
    _showErrors: function(xhr, prefix) {
      var errors, ref, ref1;
      errors = (ref = (ref1 = xhr.responseJSON) != null ? ref1.errors : void 0) != null ? ref : ['未知错误'];
      return Skylark.Bridge.newAlertify(`${prefix}：${errors.join('，')}`, {
        type: 'danger'
      });
    },
    _normalizeIngredients: function(ingredients) {
      return _.map(ingredients, (ingredient) => {
        return this._decorateIngredient(ingredient);
      });
    },
    _decorateIngredient: function(ingredient) {
      return _.extend({}, ingredient, {
        mode: 'show',
        editForm: {}
      });
    }
  }
});
